import { useViewsSelectAllStore } from '~/components/v2/store/features/views/useViewsSelectAllStore';
import { useHasCurrentWorkspaceProvider } from '~/providers/CurrentWorkspaceProvider';

/**
 * Temporary width override for shared gallery/context-menu chrome (also used on public share).
 *
 * @TODO(WORK-714): Delete this hook once cyan NEW badges are retired — `w-[288px]` only exists
 * to fit hero labels. Prefer primitive dropdown sizing (or no override) after WORK-714. Hero rows
 * and private gating stay in `useWorkspaceAgentSelectionMenuHeroOptions`.
 *
 * No width on public share (`CurrentWorkspaceProvider` absent).
 */
export const useWorkspaceAgentMenuDropdownClassName = () => {
  const selectAll = useViewsSelectAllStore((state) => state.selectAll);
  const hasCurrentWorkspace = useHasCurrentWorkspaceProvider();

  // @TODO(WORK-714): Remove with this hook — temporary width hack for hero NEW labels.
  const selectionMenuDropdownClassName = hasCurrentWorkspace && !selectAll ? 'w-[288px]' : undefined;

  return { selectionMenuDropdownClassName };
};
